/* eslint-disable react/jsx-key */
import React, { useEffect, useState } from 'react';
import Header3 from '../components/header/header-rslhome';
import Footer3 from '../components/footer/footer-3';
import { useRouter } from 'next/router';
import DetailsContent from '../components/blog/blog-details/DataPrivacyPolicy';
import { policyList, policyView } from '../redux/slices/product';
import { useDispatch, useSelector } from 'react-redux';
import Seo from '../components/common/Seo';
import { Skeleton } from '@mui/material';

const PrivacyUrl = () => {
  const router = useRouter();
  const { policyListRes, policyViewRes } = useSelector(
    (state) => state.product
  );
  const dispatch = useDispatch();
  const id = router.query.id;
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const [view, setView] = useState([]);

  // Policy List api

  useEffect(() => {
    dispatch(policyList()).then(() => {
      setTimeout(() => setIsLoading(false), 1000);
    });
  }, [dispatch]);

  useEffect(() => {
    if (policyListRes) {
      setData(policyListRes);
    }
  }, [policyListRes]);

  // Policy View

  useEffect(() => {
    dispatch(policyList());
    if (!id) <h1>Loading...</h1>;
    else dispatch(policyView(id));
    // else setBlogItem(blogsData.find((item) => item.id == id));

    return () => {};
  }, [id]);

  useEffect(() => {
    if (policyViewRes) {
      setView(policyViewRes);
    }
  }, [policyViewRes]);

  
  

  return (
    <>
      <Seo pageTitle="PRIVACY POLICY - Royalsmartlimousine - Lifestyle" />
      
      <div className="careers-main mt-careers-main">
        <div className="rule"></div>
        <div className="container">
          <div className="careers-content">
            <h3 className="text-center mb-10">Data Privacy Policy</h3>
            {/* {data.map((item,index)=>
                <>
                 <DetailsContent 
                 content={item?.policies}
                  />
                 </>
                )} */}
            {isLoading ? (
              <div>
                {[1, 2, 3, 4, 5].map((line) => (
                  <Skeleton
                    key={line}
                    // animation="wave"
                    variant="text"
                    width={'100%'}
                    height={40}
                  />
                ))}
              </div>
            ) : (
              data.map((item, index) => (
                <DetailsContent content={item?.policies} key={index} />
              ))
            )}
          </div>
        </div>
      </div>

      <Footer3 />
    </>
  );
};

export default PrivacyUrl;
